import React from "react";

import ActionLink from "../../../components/admin/ActionLink";
import InfoCard from "../../../components/admin/InfoCard";
import PageIntro from "../../../components/admin/PageIntro";
import Pill from "../../../components/admin/Pill";
import SectionCard from "../../../components/admin/SectionCard";

export default function ProviderPlansAdminPage() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
      <PageIntro
        title="Provider plans"
        description="Manage provider-facing commercial plans here. This area will support plan definitions, pricing visibility, and future subscription lifecycle workflows."
      />

      <SectionCard
        eyebrow="Commercial configuration"
        title="Provider plan management is ready for backend seeding"
        description="Use this screen as the future workspace for provider subscription plans, commercial models, plan status, and operational actions across the HnB platform."
      >
        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
          <Pill label="Provider subscriptions" />
          <Pill label="Commercial models" />
          <Pill label="ERP expansion ready" />
        </div>
      </SectionCard>

      <section
        style={{
          background: "#ffffff",
          border: "1px solid #e5e7eb",
          borderRadius: "16px",
          padding: "28px",
          display: "flex",
          flexDirection: "column",
          gap: "14px",
          alignItems: "flex-start",
        }}
      >
        <div
          style={{
            width: "56px",
            height: "56px",
            borderRadius: "14px",
            background: "#eef2ff",
            color: "#4338ca",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "1.5rem",
            fontWeight: 700,
          }}
        >
          P
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <h2 style={{ margin: 0, fontSize: "1.15rem", color: "#111827" }}>
            No provider plans yet
          </h2>

          <p
            style={{
              margin: 0,
              color: "#6b7280",
              lineHeight: 1.6,
              maxWidth: "60ch",
            }}
          >
            Provider subscription plan records have not been seeded from the backend
            yet. Once data is available, this page can support plan lists, pricing
            summaries, status visibility, and plan-management workflows for the
            provider side of HnB.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
          <ActionLink
            to="/staff/dashboard/platform-settings"
            label="Review platform settings"
          />
          <ActionLink
            to="/staff/dashboard/providers"
            label="Review provider records"
          />
        </div>
      </section>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
          gap: "16px",
        }}
      >
        <InfoCard
          title="Planned records"
          body="This module can later surface plan names, billing models, pricing values, duration, and active status."
        />
        <InfoCard
          title="Planned actions"
          body="Future actions can include plan creation, pricing updates, activation and retirement, and provider assignment workflows."
        />
        <InfoCard
          title="Why it matters"
          body="Clear provider plans improve commercial clarity, subscription governance, and future reporting across the HnB ERP structure."
        />
      </div>
    </div>
  );
}